import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { Snackbar as MuiSnackbar } from "@mui/material";
import { Info } from "lucide-react";

import { showHideSnackbar } from "./../../store/Snackbar/actions";
import { mustCompleteCompanyRegistration } from "../../utils/companyRegistration";
import { ROUTE_PATHS } from "../../utils/RoutesPaths";

import "./Snackbar.scss";

const Snackbar = () => {
  const dispatch = useDispatch();
  const { pathname } = useLocation();
  const isAuthenticated = useSelector((state) => !!state.auth.login?.auth_token);
  const isAuthLayoutContext =
    !isAuthenticated ||
    pathname === ROUTE_PATHS.changePassword ||
    mustCompleteCompanyRegistration();

  const showSnackbar = useSelector((state) => state.snackbar.showSnackbar);
  const message = useSelector((state) => state.snackbar.message);
  const title = useSelector((state) => state.snackbar.title);
  const type = useSelector((state) => state.snackbar.type);

  const [msgsArr, setMsgsArr] = useState([]);

  useEffect(() => {
    if (type === "error") {
      setMsgsArr([]);
      return;
    }

    setMsgsArr(message ? message.split(",") : []);
  }, [message, type]);

  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    dispatch(
      showHideSnackbar({
        isOpen: false,
        type,
        message,
      }),
    );
  };

  const anchorOrigin = { vertical: "top", horizontal: "center" };

  return (
    <div
      className={[
        "snackbar-container",
        isAuthLayoutContext ? "snackbar-container--auth-layout" : "",
      ]
        .filter(Boolean)
        .join(" ")}
    >
      <MuiSnackbar
        open={showSnackbar}
        autoHideDuration={5000}
        onClose={handleClose}
        anchorOrigin={anchorOrigin}
        className={`snackbar ${type} alert_no_1`}
        message={
          type === "error" ? (
            <div className="snackbar-message">
              <Info className="snackbar-message__icon" aria-hidden="true" />
              {title ? (
                <span className="snackbar-message__body">
                  <span className="snackbar-message__title">{title}</span>
                  <span className="snackbar-message__text">{message}</span>
                </span>
              ) : (
                <span className="snackbar-message__text">{message}</span>
              )}
            </div>
          ) : type === "warning" ? (
            <div className="snackbar-message">
              <Info className="snackbar-message__icon" aria-hidden="true" />
              <span className="snackbar-message__text">{message}</span>
            </div>
          ) : (
            <div className="snackbar-message">
              <Info className="snackbar-message__icon" aria-hidden="true" />
              {title ? (
                <span className="snackbar-message__body">
                  <span className="snackbar-message__title">{title}</span>
                  <span className="snackbar-message__text">
                    {msgsArr[0] || message}
                  </span>
                </span>
              ) : (
                <span className="snackbar-message__text">
                  {msgsArr[0] || message}
                </span>
              )}
            </div>
          )
        }
      />
    </div>
  );
};

export default Snackbar;
